import { useCallback, useEffect, useState } from 'react';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';

export type AiOffer = { id: string; monthly: boolean; pence: number; credits: number; label: string };
export type AiBalance = {
  tier: string | null;
  status: string;
  periodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  monthlyAllowance: number;
  monthlyLeft: number;
  topup: number;
  available: number;
};
export type AiAccess = {
  state: 'ALLOWED' | 'NOT_RELEASED' | 'NOT_BOUGHT' | 'NO_CREDITS';
  visible: boolean;
  developer: boolean;
  released: boolean;
  canBuy: boolean;
  balance: AiBalance;
  offers: AiOffer[];
  history: { kind: string; credits: number; feature: string | null; at: string }[];
  termsAccepted: boolean;
  termsVersion: string;
};

const listeners = new Set<() => void>();

export function refreshAiAccess() {
  listeners.forEach((l) => l());
}

export function useAiAccess(): { access: AiAccess | null; refresh: () => void } {
  const { token } = useAuth();
  const [access, setAccess] = useState<AiAccess | null>(null);
  const load = useCallback(() => {
    if (!token) { setAccess(null); return; }
    api<AiAccess>('/ai/access', { token }).then(setAccess).catch(() => setAccess(null));
  }, [token]);
  useEffect(() => {
    load();
    listeners.add(load);
    return () => { listeners.delete(load); };
  }, [load]);
  return { access, refresh: refreshAiAccess };
}
